import * as Turbo from "@hotwired/turbo"
Turbo.session.drive = false

import { Application } from "@hotwired/stimulus"
import SupportSearchController from "../controllers/support/search_controller.ts"
import SupportVoteController from "../controllers/support/vote_controller.ts"
import WeightUnitController from "../controllers/weight_unit_controller.ts"
import HeaderController from "../controllers/header_controller.ts"
import FeaturesSwitcherController from "../controllers/features_switcher_controller.ts"
import FeaturesVoteController from "../controllers/features/vote_controller.ts"
import PhoneSelectController from "../controllers/phone_select_controller.ts"
import NumberInputController from "../controllers/number_input_controller.ts"
import SearchComboController from "../controllers/search_combo_controller.ts"
import IndeterminateCheckboxController from "../controllers/indeterminate_checkbox_controller.ts"
import PopoverMenuController from "../controllers/popover_menu_controller.ts"
import AlertController from "../controllers/alert_controller.ts"
import LitepickerController from "../controllers/litepicker_controller.ts"
import LitepickerRangeController from "../controllers/litepicker_range_controller.ts"
import UploadController from "../controllers/upload_controller.ts"

declare global {
  interface Window {
    Turbo: typeof Turbo
    Stimulus: Application
  }
}

window['Turbo'] = Turbo
window['Stimulus'] = Application.start()
window['Stimulus'].register("support--search", SupportSearchController)
window['Stimulus'].register("support--vote", SupportVoteController)
window['Stimulus'].register("weight-unit", WeightUnitController)
window['Stimulus'].register("header", HeaderController)
window['Stimulus'].register("features-switcher", FeaturesSwitcherController)
window['Stimulus'].register("features--vote", FeaturesVoteController)
window['Stimulus'].register("phone-select", PhoneSelectController)
window['Stimulus'].register("number-input", NumberInputController)
window['Stimulus'].register("search-combo", SearchComboController)
window['Stimulus'].register("indeterminate-checkbox", IndeterminateCheckboxController)
window['Stimulus'].register("popover-menu", PopoverMenuController)
window['Stimulus'].register("alert", AlertController)
window['Stimulus'].register("litepicker", LitepickerController)
window['Stimulus'].register("litepicker-range", LitepickerRangeController)
window['Stimulus'].register("upload", UploadController)

document.addEventListener("turbo:before-fetch-request", async (event) => {
  event.preventDefault()

  if (/^\/support\/[^\/]+\/[^\/]+/.test(event.detail.url.pathname)) {
    event.detail.fetchOptions.headers["Accept"] = "text/vnd.turbo-stream.html, text/html, application/xhtml+xml"
  }

  event.detail.resume()
})

window.addEventListener("popstate", event => {
  const path = window.location.pathname

  if (/^\/support\/[^\/]+\/[^\/]+/.test(path)) {
    Turbo.visit(path, { action: "replace" }) // the Accept header is set in turbo:before-fetch-request above
  } else {
    Turbo.visit(path)
  }
})
